var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "platform-notice", attrs: { title: "平台公告" } },
    [
      _c(
        "ul",
        [
          _vm._l(_vm.notice, function(cont, index) {
            return [
              _c(
                "li",
                {
                  key: index,
                  staticClass: "ellipsis",
                  on: {
                    click: function($event) {
                      return _vm.$openHome(
                        cont.url + "?colCode=sc_code",
                        "通知公告",
                        1,
                        1
                      )
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(cont.title) + "\n      ")]
              )
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }